export default "__VITE_ASSET__CmI7TLTf__"